import Instrumento from "@/models/Instrumento";
import Consumivel from "@/models/Consumivel";
import Profissional from "../models/Profissional";

export default class ParticulaMagnetica {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.material = "Aço Carbono";
    this.tecnica = "Técnica do Yoke";
    this.via = "Úmida (Distensor/Água)";
    this.decantacao = "1,6ml/100ml";
    this.corrente = "Alternada";
    this.temperatura = this.randomNumber() + " °C";
    this.superficie = "Escovada / Limpa";
    this.itens = this.getDefaultItens();
    this.norma = "ASME VIII, Div. 1, Ap. 6, Ed. 2004";
    this.procedimento = "";
    this.observacao = "";
    this.instrumento = new Instrumento();
    this.distensor = new Consumivel();
    this.particula = new Consumivel();
    this.inspetor = new Profissional();
  }

  update(pm) {
    this.numero = pm.numero;
    this.data = pm.data;
    this.material = pm.material;
    this.tecnica = pm.tecnica;
    this.via = pm.via;
    this.decantacao = pm.decantacao;
    this.corrente = pm.corrente;
    this.temperatura = pm.temperatura;
    this.superficie = pm.superficie;
    this.itens = pm.itens;
    this.norma = pm.norma;
    this.procedimento = pm.procedimento;
    this.observacao = pm.observacao;
    this.instrumento = pm.instrumento;
    this.distensor = pm.distensor;
    this.particula = pm.particulas;
    this.inspetor = pm.inspetor;
  }

  randomNumber() {
    return parseFloat(Math.random() * (36 - 20) + 20).toFixed(1);
  }

  getDefaultItens() {
    let list = [];
    for (let index = 0; index < 6; index++) {
      list.push({
        quantidade: "- - -",
        descricao: "- - -",
        local: "- - -",
        tipo: "- - -",
        dimensao: "- - -",
        laudo: "- - -",
      });
    }
    return list;
  }
}
